module.exports = __webpack_public_path__ + "static/media/121151.255ccec1.jpg";